import { render, staticRenderFns } from "./case.vue?vue&type=template&id=535be0d1&scoped=true&"
import script from "./case.vue?vue&type=script&lang=js&"
export * from "./case.vue?vue&type=script&lang=js&"
import style0 from "./case.vue?vue&type=style&index=0&id=535be0d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535be0d1",
  null
  
)

export default component.exports